import React from 'react';
import styled from 'styled-components';

import AnimatedSpinner from '@rover/components/src/typography/AnimatedSpinner';
import { Heading, Paragraph } from '@rover/kibble/core';
import MQ from '@rover/kibble/styles/MediaQuery';
import {
  Alignment,
  HorizontalLayout,
  VerticalLayout,
} from '@rover/react-lib/src/components/layouts';

const StyledLayout = styled(VerticalLayout)`
  min-height: 336px;
  padding: 20px;
  width: 100%;
  justify-content: center;
  text-align: center;

  ${MQ.XS_DOWN.toString()} {
    min-height: 200px;
  }
`;
const StyledAnimatedSpinner = styled(AnimatedSpinner)`
  margin-right: ${({ theme }) => theme.space['2x']};
`;
export type Props = {
  title: string;
  subtitle?: string;
  showSpinner?: boolean;
};

const ErrorMessage = ({ title, subtitle, showSpinner = false }: Props): JSX.Element => (
  <StyledLayout hAlign={Alignment.CENTER}>
    <HorizontalLayout hAlign={Alignment.CENTER} vAlign={Alignment.CENTER}>
      {showSpinner && <StyledAnimatedSpinner diameter={20} />}
      <Heading size="300" webProps={{ as: 'div' }}>
        {title}
      </Heading>
    </HorizontalLayout>
    {subtitle && (
      <Paragraph textAlign="center" mt="0x" textColor="secondary">
        {subtitle}
      </Paragraph>
    )}
  </StyledLayout>
);

export default ErrorMessage;
